export default __webpack_public_path__ + "static/media/labelimg4.ad784600.jpg";